namespace $.$$ {

	$mol_style_define( $shm_ba_chart_timeseries, {
		position: 'relative',
		height: '400px',
		minHeight: '400px',
		Left_tools: {
			position: 'absolute',
			top: '8px',
			zIndex: $mol_layer.hover,
			background: {
				color: $mol_theme.back,
			},
		},
		Tools: {
			position: 'absolute',
			top: '8px',
			right: '8px',
			zIndex: $mol_layer.hover,
			background: {
				color: $mol_theme.back,
			},
		},
		Group_select: {
			minHeight: 0,
			background: {
				color: $mol_theme.card,
			},
		},
	} )

}
